/**
 * The 20 game archetypes GenieForge ships templates for.
 * Mirrors the list in CLAUDE.md and the GDD catalog.
 */
export const ARCHETYPES = [
	"creature-collector",
	"endless-runner",
	"block-puzzle",
	"match-3",
	"merge",
	"idle-clicker",
	"tower-defense",
	"platformer",
	"top-down-rpg",
	"io-arena",
	"virtual-pet",
	"fashion",
	"tycoon",
	"card-battle",
	"survival-horror",
	"racing",
	"farming-sim",
	"word-trivia",
	"board-game",
	"social-hangout",
] as const;

export type Archetype = (typeof ARCHETYPES)[number];

/**
 * Human-readable labels for archetypes. Used in category pills, filters, and
 * game detail pages.
 */
export const ARCHETYPE_LABELS: Record<Archetype, string> = {
	"creature-collector": "Creature Collector",
	"endless-runner": "Endless Runner",
	"block-puzzle": "Block Puzzle",
	"match-3": "Match-3",
	merge: "Merge",
	"idle-clicker": "Idle / Clicker",
	"tower-defense": "Tower Defense",
	platformer: "Platformer",
	"top-down-rpg": "Top-Down RPG",
	"io-arena": ".io Arena",
	"virtual-pet": "Virtual Pet",
	fashion: "Dress-Up",
	tycoon: "Tycoon",
	"card-battle": "Card Battle",
	"survival-horror": "Horror",
	racing: "Racing",
	"farming-sim": "Farming",
	"word-trivia": "Word",
	"board-game": "Board Game",
	"social-hangout": "Social",
};

/**
 * A thumbnail is intentionally lightweight for MVP — a background color plus
 * an emoji glyph. Replaced by real screenshots once templates ship.
 */
export interface Thumbnail {
	bg: string;
	fg: string;
	emoji: string;
}

export interface Game {
	id: string;
	slug: string;
	title: string;
	creator: string;
	thumbnail: Thumbnail;
	archetype: Archetype;
	/** Lifetime play count (placeholder value for MVP). */
	plays: number;
	/** 0–5 star rating (placeholder value for MVP). */
	rating: number;
	description: string;
	tags: string[];
	/**
	 * Where the "PLAY NOW" button points. For MVP every entry is a placeholder
	 * hash (`#`) — real play URLs (`games.genieworlds.games/:slug/`) are wired
	 * in once the first template ships to R2.
	 */
	playUrl: string;
	featured?: boolean;
	trending?: boolean;
	/** ISO date — drives "New Releases" row sort. */
	publishedAt: string;
}

/** Sort modes exposed on the Browse page. */
export type SortMode = "trending" | "new" | "popular" | "top-rated";
